// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
import { veicleTypeDefault } from "./constants";

const initialState = {
  data: null,
  getLineasFinancierasPending: false,
  getLineasFinancierasError: null,
  columnsList: 'tipoMMV,entidadOtorgante,nombreLineaComercial,Tasa,montoMaximo,porcMontoMaxFinanciar,estadoLCDesc,lc_id',
  columns: [
    {
      text: 'Tipo de vehículo',
      dataField: 'tipoMMV',
      sort: true,
    },
    {
      text: 'Entidad otorgante',
      dataField: 'entidadOtorgante',
      sort: true,
    },
    {
      text: 'Nombre comercial',
      dataField: 'nombreLineaComercial',
      sort: true,
    },
    {
      text: 'Tipo de tasa',
      dataField: 'Tasa',
      sort: true,
    },
    {
      text: 'Monto a financiar',
      dataField: 'montoMaximo',
      sort: true,
    },
    {
      text: '% Máximo a financ.',
      dataField: 'porcMontoMaxFinanciar',
      sort: true,
    },
    {
      text: 'Estados',
      dataField: 'estadoLCDesc',
      sort: true,
    }
  ],
  lineasFinancieras: [],
  lineasFinancierasPagination: {
    total: 0,
    page: 1,
    pages: 1,
    nextPage: null,
    prevPage: null
  },
  altaLineaSettings: {
    pasos: [
      {
        id: 1,
        name: 'Datos financieros',
        active: true,
        selected: true
      },
      {
        id: 2,
        name: 'Asignación de líneas',
        active: false,
        selected: false
      }
    ],
    pasoSelected: {
      id: 1,
      name: 'Datos financieros',
      active: true,
      selected: true
    }
  },
  veicleType: veicleTypeDefault,
  altaNuevaLinea: {
    id: null,
    datosFinancieros: {
      entidadOtorgante: {},
      tipoCredito: {},
      lineaCreditoBancaria: '',
      lineaComercial: '',
      tipoTasa: {},
      cuotas: [],
      cuotasPreviousValues: [],
      requisitos: '',
      fechaVigenciaIni: null,
      fechaVigenciaFin: null,
      promocionClienteBanco: true,
      beneficio: '',
      bloqueado: false,
      exceedFinanceLimit: false,
    },
    asignacionLineas: {
      tipoVehiculo: true,
      antiguedad: {},
      marca: { label: 'Todas', value: null, id: 'marca' },
      modelo: { label: 'Todos', value: null, id: 'modelo' },
      version: { label: 'Todas', value: null, id: 'version' },
      lineas: []
    }
  },
  editLinea: false,
  editLineaData: {
    id: null,
    datosFinancieros: {
      entidadOtorgante: {},
      tipoCredito: {},
      lineaCreditoBancaria: '',
      lineaComercial: '',
      tipoTasa: {},
      cuotas: [],
      cuotasPreviousValues: [],
      cuotasDeleted: [],
      requisitos: '',
      fechaVigenciaIni: null,
      fechaVigenciaFin: null,
      promocionClienteBanco: true,
      beneficio: '',
      exceedFinanceLimit: false,
    },
    asignacionLineas: {
      tipoVehiculo: true,
      antiguedad: {},
      marca: { label: 'Todas', value: null, id: 'marca' },
      modelo: { label: 'Todos', value: null, id: 'modelo' },
      version: { label: 'Todas', value: null, id: 'version' },
      lineas: [],
      lineasDeleted: []
    }
  },
  entidadesOtorgantes: [],
  tiposCredito: [],
  tiposTasa: [],
  marcas: [],
  modelos: [],
  versiones: [],
  getEntidadesOtorgantesPending: false,
  getEntidadesOtorgantesError: null,
  getTiposCreditoPending: false,
  getTiposCreditoError: null,
  getBrandsPending: false,
  getBrandsError: null,
  getModelsPending: false,
  getModelsError: null,
  getVersionsPending: false,
  getVersionsError: null,
  comparadorDeLineas: {
    lineas: [],
    lineasFiltradas: [],
    entidadOtorgante: null,
    lineaCreditoNombre: null,
    lineasCreditoNombre: [],
    tipoTasa: null
  },
  confirmEditCuotaAsyncPending: false,
  confirmEditCuotaAsyncError: null,
  newLineaFinancieraPending: false,
  newLineaFinancieraError: null,
  getTiposTasaPending: false,
  getTiposTasaError: null,
  getLineaFinancieraByIdPending: false,
  getLineaFinancieraByIdError: null,
  getCreditsComparePending: false,
  getCreditsCompareError: null,
  updateLineaFinancieraPending: false,
  updateLineaFinancieraError: null,
  simulacionFinanciacion: {
    lineasPorMontoTotal: [],
    lineasPorCuotaMensual: []
  },
  getLineasSimulacionFinanciacionPending: false,
  getLineasSimulacionFinanciacionError: null
};

export default initialState;
